import { Link } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import api from '../api/api';
import Loader from '../shared/loader';
import arrayUtilities from '../../utilities/arrayUtilities';
import { Modal, Button } from 'react-bootstrap';
import stringHelpers from '../../utilities/stringHelpers';
import { ErrorModal } from '../../utilities/errorModal';

export default function AppealSupplementaryResponses({ user, organisationId, token }) {
    const [appealSupplementaryResponses, setAppealSupplementaryResponses] = useState(null);
    const [isLoading, setIsLoading] = useState(false)
    const [deleteModal, setDeleteModal] = useState(null)
    const [errorMessage, setErrorMessage] = useState(null)
    const [responseDetailsModal, setResponseDetailsModal] = useState(null)

    const getAppealSupplementaryResponses = function () {
        setIsLoading(true)
        api.getAppealSupplementaryResponses(
            (data) => {
                setAppealSupplementaryResponses(data)
                setIsLoading(false)
            },
            (error) => {
                console.log(error)
                setIsLoading(false)
            },
            organisationId,
            token
        )
    };

    useEffect(() => {
        getAppealSupplementaryResponses();
    }, []);

    const handleDelete = () => {
        api.deleteAppealSupplementaryResponse(
            data => {
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                } else {
                    getAppealSupplementaryResponses();
                }
            },
            error => {
                console.log(error)
                setErrorMessage(error.message)
            },
            deleteModal.id,
            organisationId, token
        )
    }

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="card mb-3">
                        <div className="card-header">
                            <div className="row align-items-center justify-content-between">
                                <div className="col-auto d-flex align-items-center pr-0">
                                    <h5 className="mb-0">Appeal Supplementary Responses</h5>
                                </div>
                                <div className="col-auto text-right pl-0 filter-buttons-wrapper">
                                    <Link className="btn btn-success btn-sm mr-1 ml-1" to={ `/organisation/${ organisationId }/appeal-supplementary-response` }><i className="fas fa-plus mr-1"></i>Add</Link>
                                </div>
                            </div>
                        </div>
                        <div className="card-body bg-light border-top p-0">
                            <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer" style={ { tableLayout: 'fixed' } }>
                                <thead className="bg-200 text-900">
                                    <tr>
                                        <th style={ { width: '20%' } }>Name</th>
                                        <th style={ { width: "300px" } }>Content</th>
                                        <th style={ { width: '150px' } }>&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { isLoading
                                        ? <tr> <td colSpan={ 3 }><Loader /></td></tr>
                                        : !arrayUtilities.isNullOrEmpty(appealSupplementaryResponses) && appealSupplementaryResponses.map((response) =>
                                            <tr key={ response.id }>
                                                <td className="text-truncate"><Link to={ `/organisation/${ organisationId }/appeal-supplementary-response/${ response.id }` }><h6 className="mb-0">{ response.name }</h6></Link></td>
                                                <td className="text-truncate" title={ response.content }>{ response.content }</td>
                                                <td className='text-right pr-3'>
                                                    <button onClick={ () => setResponseDetailsModal(response) } className='btn btn-none p-0 m-0 mr-1' type='button'>
                                                        <i className='far fa-eye'></i>
                                                    </button>
                                                    <Link to={ {
                                                        pathname: `/organisation/${ organisationId }/appeal-supplementary-response/${ response.id }`,
                                                        state: { editMode: true }
                                                    } } className='btn btn-none p-0 m-0 ml-2' type='button'>
                                                        <i className='fas fa-edit'></i>
                                                    </Link>
                                                    <button onClick={ () => setDeleteModal(response) } className='btn btn-none p-0 m-0 ml-2' type='button'>
                                                        <i className='fas fa-trash-alt'></i>
                                                    </button>
                                                </td>
                                            </tr>)
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {
                deleteModal &&
                <Modal show onHide={ () => setDeleteModal(null) } centered>
                    <Modal.Header>
                        <Modal.Title className="d-flex gap-2 align-items-center text-danger">Delete Supplementary Response</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p className="font-weight-semi-bold mt-1 mb-2">Are you sure you want to delete <b>{ deleteModal.name }</b>?</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={ () => setDeleteModal(null) }>Cancel</button>
                        <button type="button" className="btn btn-danger btn-sm ml-2" onClick={ () => {
                            setDeleteModal(null)
                            handleDelete()
                        } }>Delete</button>
                    </Modal.Footer>
                </Modal>
            }
            { !stringHelpers.isNullOrEmpty(errorMessage) && <ErrorModal message={ errorMessage } onHide={ () => setErrorMessage(null) } /> }

            {
                responseDetailsModal &&
                <Modal size='lg' show onHide={ () => setResponseDetailsModal(null) } centered>
                    <Modal.Header>
                        <Modal.Title>Appeal Supplementary Response</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <div className="row mb-3">
                                <div className="col-4">
                                    <p className="font-weight-semi-bold m-0">Name</p>
                                </div>
                                <div className="col-8">
                                    <p className="m-0">{ responseDetailsModal.name }</p>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-4">
                                    <p className="font-weight-semi-bold m-0">Content</p>
                                </div>
                                <div className="col-8">
                                    <p className="m-0">{ responseDetailsModal.content }</p>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button size="sm" variant='secondary' onClick={ () => setResponseDetailsModal(false) }>Close</Button>
                    </Modal.Footer>
                </Modal>
            }

        </div>
    )
}